var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoaded)?_c('section',[_c('HeaderBackground',{attrs:{"backgroundPath":("/" + _vm.$staticPath + "/" + (_vm.index.background))}}),_vm._v(" "),_c('div',{staticClass:"content"},[_c('Header',{attrs:{"headerText":_vm.index.headerText}}),_vm._v(" "),_c('NewsList',{attrs:{"filterProp":_vm.content.filter}})],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53c21442","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/News/Index.vue
// module id = null
// module chunks = 